import { render } from "./LevelCard.vue?vue&type=template&id=2cb0022b&scoped=true"
import script from "./LevelCard.vue?vue&type=script&lang=js"
export * from "./LevelCard.vue?vue&type=script&lang=js"

import "./LevelCard.vue?vue&type=style&index=0&id=2cb0022b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb0022b"]])

export default __exports__